<template>
  <div class="main-content-container overflow-hidden">
    <div class="row">
      <div class="col-md-6">
        <ItemByGroupCategory />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ItemByGroupCategory from "@/components/Dashboard/Widget/ItemByGroupCategory.vue";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "ItemGroupCategoryDashbooard",
  components: {
    ItemByGroupCategory,
  },
});
</script>
